import Apis from '@model';

function formatData(dataList) {
  let result = [];
  dataList.forEach(item => {
    result.push(item.name);
  });
  return result;
}

function getQueryString(name) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  let r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  };
  return null;
}

export async function getFirmLists(value) {
  try {
    const { result, data } = await Apis.getComanyInfo(value);
    if (result === 'success' && data) {
      return formatData(data.items);
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
}

export function getActiveParams() {
  const sn = getQueryString('sn');
  const pcsn = getQueryString('pcsn');
  const masterSn = getQueryString('masterSn');
  const opsBrand = getQueryString('opsBrand');
  const sign = getQueryString('sign');
  const osName = getQueryString('osName');
  const opsModel = getQueryString('opsModel');
  const opsSn = getQueryString('opsSn');
  const masterModel = getQueryString('masterModel');
  const masterVersion = getQueryString('masterVersion');
  const softwareBrand = getQueryString('softwareBrand');
  const baseParam = {
    masterSn,
    opsBrand,
    masterVersion,
    sign,
    osName,
    opsModel,
    opsSn,
    masterModel
  };
  return {
    baseParam,
    sn,
    pcsn,
    extra: JSON.stringify({softwareBrand}),
  };
}



// WEBPACK FOOTER //
// ./src/business/views/DataManager/index.js